<template>
  <div class="play-control">
    <el-button type="primary"
               size="mini"
               round
               :disabled="isLoading"
               @click="togglePlay">
      {{playId===null?'播放':'暂停'}}
    </el-button> &nbsp;&nbsp;&nbsp;
    <el-checkbox class="play-control-auto"
                 v-model="autoPlay">自动播放</el-checkbox>
    <el-slider class="play-control-slider"
               show-input
               input-size="mini"
               :min="0"
               :max="frameCount?frameCount-1:1"
               :disabled="isLoading"
               v-model="frameIdx"></el-slider>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { mapFields } from 'vuex-map-fields'
import storejs from 'store'

export default {
  data() {
    return {
      playId: null,
      autoPlay: !!storejs.get('playControl:autoPlay'),
    }
  },
  computed: {
    ...mapState(['frameCount', 'isPlaying']),
    ...mapGetters(['isLoading']),
    ...mapFields(['frameIdx', 'isPlaying']),
  },
  methods: {
    play() {
      if (this.isPlaying === false) {
        return
      }
      if (this.frameIdx < this.frameCount - 1) {
        this.frameIdx++
        this.playId = window.requestAnimationFrame(this.play)
      } else {
        this.frameIdx = 0
        this.playId = null
        this.isPlaying = false
      }
    },
    stop() {
      window.cancelAnimationFrame(this.playId)
      this.playId = null
      this.isPlaying = false
    },
    togglePlay() {
      this.isPlaying = !this.isPlaying
    },
  },
  watch: {
    isPlaying(val) {
      val ? this.play() : this.stop()
    },
    autoPlay(val) {
      storejs.set('playControl:autoPlay', val)
    },
  },
  beforeDestroy() {
    this.stop()
  },
}
</script>

<style lang="scss" scoped>
.play-control {
  display: flex;
  align-items: center;
  margin: 0 10px;
  &-slider {
    flex: 1;
    margin-left: 10px;
  }
  &-auto {
    margin-right: 5px;
  }
}
</style>
